document.addEventListener("turbo:load", function () {
  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    if (!anchor.hash) return;
    anchor.addEventListener("click", function (e) {
      e.preventDefault();

      if (document.body.dataset.scrollOffset) {
        const yOffset = parseInt(document.body.dataset.scrollOffset);
        const element = document.querySelector(anchor.hash);
        const y =
          element.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({ top: y, behavior: "smooth" });
      } else {
        document.querySelector(this.getAttribute("href")).scrollIntoView({
          behavior: "smooth",
        });
      }
    });
  });
});
